<template>
  <div class="info-card" data-arrow="left">
    <div class="icon" v-if="icon">
      <i :class="`icon-${icon}`" />
    </div>
    <div class="info">
      <slot />
    </div>
    <dots class="small left white">
      <ul>
        <li @click="$emit('dismiss', true)">Hide this message</li>
      </ul>
    </dots>
  </div>
</template>

<script>

import Dots from '@/components/Dots.vue';

export default {
  components: {
    Dots,
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    iconCircle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.info-card {
  background: var(--color-notification-blue);
  border-radius: 10px;
  box-shadow: 0 2px 4px 0 rgb(165 179 194 / 20%), 0 0 1px 0 rgb(165 179 194 / 50%);
  // display: flex;
  // flex-direction: column;
  padding: 20px 32px;
  position: relative;

  .dots {
    position: absolute;
    right: 16px;
    top: 16px;
  }

    &:after {
      content: "";
      clear: both;
      display: table;
    }

  &[data-arrow]:not([data-arrow=""]) {
    &:before {
      bottom: 100%;
      left: 50px;
      border: solid transparent;
      content: "";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(0, 0, 0, 0);
      border-bottom-color: var(--color-notification-blue);
      border-width: 16px;
      margin-left: -16px;
    }
  }

  .icon {
    color: var(--color-notification-blue);
    background-color: #B5D0F0;
    align-items: center;
    display: flex;
    justify-content: center;
    border-radius: 66px;
    font-size: 66px;
    height: 100px;
    width: 100px;
    min-height: 100px;
    min-width: 100px;
    // margin: 0 0 20px 0;
    // margin: 0 auto 20px;
    float: left;
    margin: 0 20px 20px 0;

    &[data-circle="true"] {
      shape-outside: circle();
    }
  }

  h2 {
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: 8px;
    padding-right: 56px;
  }

  p {
    color: #52586B;
    font-size: 16px;
    margin-bottom: 8px;
    line-height: 24px;

    a {
      color: var(--color-cta-blue);
      font-weight: 500;
    }
  }

  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    flex-direction: row;

    .icon {
      margin: 0 35px 0 0;
      border-radius: 74px;
      font-size: 74px;
      height: 148px;
      width: 148px;
      min-height: 148px;
      min-width: 148px;
      float: none;
    }
  }
}
</style>
